'use client'

import { getRouterProps, getSearchRouter } from '@lib/search'
import { algoliasearch } from 'algoliasearch'
import { useRouter } from 'next/navigation'
import { useMemo, type ReactNode } from 'react'
import { Configure, InstantSearch, type ConfigureProps } from 'react-instantsearch'

type SearchPageWrapperType = {
  indexName: string
  children?: ReactNode
  searchKey: string
  searchAppId: string
  basicRouting?: boolean
  configure?: ConfigureProps
}

export default function SearchWrapper({
  indexName,
  children,
  searchKey,
  searchAppId,
  basicRouting = false,
  configure,

}: Readonly<SearchPageWrapperType>) {
  const router = useRouter()


  const searchClient = useMemo(() => {
   return algoliasearch(searchAppId, searchKey);
  }, [searchAppId, searchKey])

  const routing = useMemo(() => {
    if (basicRouting) {
      return getRouterProps(indexName)
    } else {
      return getSearchRouter(indexName, router)
    }
  }, [basicRouting, indexName, router])
  
  return (
    <InstantSearch
      searchClient={searchClient}
      indexName={indexName}
      routing={routing}
      future={{ preserveSharedStateOnUnmount: false }}
      >
        <Configure clickAnalytics={true} hitsPerPage={15} {...(configure || {})} />
        {children}
    </InstantSearch>
  )
}
